// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1WwlU","error":"Textarea_error__221cS","readonly":"Textarea_readonly__1n5-3","disabled":"Textarea_disabled__17FpU"};